
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.884","height":"27.3"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 1"}},[_c('g',{attrs:{"data-name":"Gruppe 140","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.3"}},[_c('path',{attrs:{"data-name":"Pfad 106","d":"M19.067.65H2.817a2.315 2.315 0 00-1.766.91 1.934 1.934 0 00-.4 1.257v21.667a2.39 2.39 0 00.489 1.371 2.016 2.016 0 001.678.795h16.25a2.167 2.167 0 002.167-2.167V2.817a2.66 2.66 0 00-.583-1.544A2.924 2.924 0 0019.067.65z"}}),_c('path',{attrs:{"data-name":"Pfad 108","d":"M16.9 14.238H4.988a.005.005 0 110-.011h11.917a.006.006 0 010 .011z"}}),_c('path',{attrs:{"data-name":"Pfad 109","d":"M16.9 8.231H4.988a.005.005 0 110-.011h11.917a.006.006 0 010 .011z"}}),_c('path',{attrs:{"data-name":"Pfad 108","d":"M13.028 20.238h-8.04v-.005-.005h8.045v.011z"}})])])])
          )
        }
      }
    